import React from 'react'
import classNames from 'classnames'
import shortid from 'shortid'

import styles from '../component-styles/pagination.module.scss'
import Button from './button'

interface PageProps {
  page?: number
  activePage?: number
  onChange?: any
  label?: string
  className?: string
  disabled?: boolean
}

export function Page({
  page,
  activePage,
  onChange,
  disabled,
  label,
  className,
}: PageProps): React.ReactElement | null {
  return (
    <div
      className={classNames(className, styles.paginationElement, {
        [styles.activePagination]: page === activePage,
      })}
    >
      <Button
        align="left"
        disabled={disabled}
        onClick={(): void => {
          onChange(page)
        }}
      >
        {label || page}
      </Button>
    </div>
  )
}

interface PaginationProps {
  pages: number
  activePage: number
  onChange?: any
  className?: string
}

export default function Pagination({
  pages,
  activePage,
  onChange,
  className,
}: PaginationProps): React.ReactElement | null {
  if (!pages || pages <= 1) {
    return <div />
  }
  const noConcatPages = 1
  const pageOffset = 1
  if (pages <= noConcatPages) {
    return (
      <div className={classNames(styles.paginationWrapperCenter, className)}>
        <div className={styles.paginationMiddle}>
          {[...Array(pages)].map((page: void, index: number) => {
            return (
              <Page
                key={shortid.generate()}
                page={index + pageOffset}
                activePage={activePage}
                onChange={onChange}
              />
            )
          })}
        </div>
      </div>
    )
  }
  let leftPart =
    activePage === 1 ? [1, 2, 3] : [activePage - 1, activePage, activePage + 1]
  let showMiddle = true
  if (activePage + 3 >= pages - 2) {
    leftPart = [pages - 6, pages - 5, pages - 4, pages - 3]
    showMiddle = false
  }
  const rightPart = [pages - 2, pages - 1, pages]
  return (
    <div className={classNames(className, styles.paginationWrapper)}>
      <Page
        className={styles.firstButton}
        page={1}
        onChange={onChange}
        label="First"
      />

      <div className={styles.paginationMiddle}>
        <Page
          page={0}
          // disabled={activePage === 1}
          onChange={() => {
            onChange(activePage > 1 ? activePage - 1 : 1)
          }}
          className={styles.previousButton}
          label=" "
        />
        <div className={styles.paginationMiddleMobile}>
          <span>
            {activePage}/{pages}
          </span>
        </div>
        <div className={styles.paginationMiddlePages}>
          {leftPart.map((page: number) => {
            if (page <= 0) {
              return null
            }
            return (
              <Page
                key={shortid.generate()}
                page={page}
                activePage={activePage}
                onChange={onChange}
              />
            )
          })}
          {showMiddle && (
            <div className={styles.paginationElementEmpty}>
              <Button type="inline" align="left" disabled>
                ...
              </Button>
            </div>
          )}
          {rightPart.map((page: number) => {
            if (page <= 0) {
              return null
            }
            return (
              <Page
                key={shortid.generate()}
                page={page}
                activePage={activePage}
                onChange={onChange}
              />
            )
          })}
        </div>
        <Page
          page={0}
          className={styles.nextButton}
          // disabled={activePage === pages}
          onChange={() => {
            onChange(activePage < pages ? activePage + 1 : pages)
          }}
          label=" "
        />
      </div>
      <Page
        className={styles.lastButton}
        page={pages}
        onChange={onChange}
        label="Last"
      />
    </div>
  )
}
